import React from "react";
import Select from "../../common-components/Select";
import SearchInput from "../../common-components/SearchInput";
import PrimaryButton from "../../common-components/Buttons/PrimaryButton";
import { CATEGORY_OPTIONS, STATUS_OPTIONS } from "./constants/campaignOptions";
import { useTranslation } from 'react-i18next';

const CampaignFilters = ({
  search,
  setSearch,
  category,
  setCategory,
  status,
  setStatus,
  onAddCampaign,
}) => {
  const { t } = useTranslation();

  const clearFilters = () => {
    setSearch("");
    setCategory("");
    setStatus("");
  };

  return (
    <div className="mb-4 flex flex-col gap-4 overflow-visible">
      <div className="flex flex-col sm:flex-row gap-4 items-center overflow-visible">
        <div className="w-full sm:w-64 overflow-visible">
          <SearchInput
            inputValue={search}
            placeholder="Search by title..."
            onChange={(e) => setSearch(e.target.value)}
            name="search"
          />
        </div>
        {/* <div className="w-full sm:w-48 overflow-visible relative z-10">
          <Select
            placeholder="Select category"
            options={CATEGORY_OPTIONS}
            defaultOption={CATEGORY_OPTIONS.find(opt => opt.value === category) || {}}
            onSelect={(option) => setCategory(option.value)}
            onChange={(e) => setCategory(e.target.value)}
            name="category"
            required={false}
          />
        </div>
        <div className="w-full sm:w-48 overflow-visible relative z-10">
          <Select
            placeholder="Select status"
            options={STATUS_OPTIONS}
            defaultOption={STATUS_OPTIONS.find(opt => opt.value === status) || {}}
            onSelect={(option) => setStatus(option.value)}
            onChange={(e) => setStatus(e.target.value)}
            name="status"
            required={false}
          />
        </div>
        <PrimaryButton
          buttonName={t("Clear Filters")}
          onClick={clearFilters}
          className="bg-gray-200 hover:bg-gray-300 text-gray-700 border-gray-200"
        /> */}
      </div>
    </div>
  );
};

export default CampaignFilters;

